import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './Error.styled';
import { Box } from '@material-ui/core';
import { AiFillInfoCircle } from 'react-icons/ai';

const ErrorMessage = (props) => {
  const classes = useStyles();

  return (
    <Box style={props.style} className={`error-msg ${classes.container} ${props.className || ''}`}>
      {props.hasIcon && <AiFillInfoCircle />}
      <span style={{ marginLeft: props.hasIcon ? 5 : 0 }}>{props.children}</span>
    </Box>
  );
};

ErrorMessage.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.any,
  style: PropTypes.object,
  hasIcon: PropTypes.bool,
  a: PropTypes.any,
};

ErrorMessage.defaultProps = {
  hasIcon: true,
  style: {},
};

export default ErrorMessage;
